export const ClientApi = Symbol('ClientApi')
export interface IClientApi {
	loadAndRegisterComponentsFromStructure(): Promise<any>
}
